import style from "./style.module.scss";
import icon from "../../../img/modals/security-user.svg";
import {useStore} from "effector-react";
import {$store} from "../../../store";

const PlsLogin = (props:{onLogin:Function,onRegister:Function}) => {

	const store = useStore($store);

	return (
		<div className={style.plsLogin}>
			<div className={style.icon}>
				<img src={icon} alt=""/>
			</div>
			<p className={style.title}>Авторизация</p>
			<p className={style.subtitle}>Вам необходимо авторизоваться или зарегистрироваться </p>
			<div className={style.buttons}>
				<div onClick={()=>{ props.onLogin(); }} className={`${style.btn} ${style.btnA}`}>Вход</div>
				<div onClick={()=>{ props.onRegister(); }} className={`${style.btn} ${style.btnB}`}>Регистрация</div>
			</div>
		</div>
	);
};

export default PlsLogin;
